import React from "react";
import Dispatcher from "../dispatcher";
import TransactionStore from "../stores/transaction-store";
import Price from "./price";
import RefundAction from "../actions/refund-action";
import Utils from "../utils/utils";
import { VstLoader } from "vstui";

import { Table } from "@vitalsource/vstui";

const RefundsContainer = React.createClass({
  getInitialState() {
    return { transactions: TransactionStore.getAllRefunds() };
  },

  componentDidMount() {
    Dispatcher.on(Dispatcher.TRANSACTION_STORE_CHANGE, this._onChange);
  },

  componentWillUnmount() {
    Dispatcher.removeListener(
      Dispatcher.TRANSACTION_STORE_CHANGE,
      this._onChange
    );
  },

  _onChange() {
    this.setState({ transactions: TransactionStore.getAllRefunds() });
  },

  _onDetailClick(e) {
    e.preventDefault();
    let code = e.currentTarget.dataset.code;
    RefundAction.viewDetails(code);
  },

  _renderTableRows() {
    const tableRows = this.state.transactions.map((transaction, index) => {
      let i = transaction.purchaseItems[0];
      const { currency, number, orderDate } = transaction;
      const date = new Date(orderDate);
      const price = i.quantity * Utils._itemPrice(i, currency, true);
      return {
        refunded: {
          content: Utils.toDateString(transaction.orderDate),
          sort: transaction.orderDate
        },
        title: i.title,
        total: {
          content: <Price price={price} currency={currency} />,
          sort: price
        },
        details: (
          <a
            className="details-link"
            href={`/transactions/refunds/${number}`}
            data-code={number}
            onClick={this._onDetailClick}
          >
            <span>{i18n.t("base.details")}</span>
          </a>
        )
      };
    });
    return tableRows;
  },

  _renderTableHeaders() {
    return [
      {
        header: i18n.t("refunds.refunded"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "refunded"
      },
      {
        header: i18n.t("transactions.book-title"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "title"
      },
      {
        header: i18n.t("transactions.total"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "total"
      },
      { header: "", numeric: false, hiddenHeader: false, rowKey: "details" }
    ];
  },

  render() {
    let body = (
      <div className="deck">
        <VstLoader />
      </div>
    );

    const { transactions } = this.state;
    if (transactions) {
      if (transactions.length > 0) {
        body = (
          <Table
            fullWidth
            columns={this._renderTableHeaders()}
            rows={this._renderTableRows()}
          />
        );
      } else {
        body = <p>{i18n.t("refunds.no-refunds")}</p>;
      }
    }

    return body;
  }
});

export default RefundsContainer;
